const routers = [
  {
    path: '/fatcamp/into',
    name: 'fatcamp-into',
    component: () => import('@/views/business-center/views/into/index'),
    meta: { title: '首页', des: '进入首页' }
  },
  {
    path: '/fatcamp/login',
    name: 'fatcamp-login',
    component: () => import('@/views/business-center/views/login/index'),
    meta: { title: '登录', des: '登录', scrollTop: 0, keepScroll: true }
  },
  {
    path: '/fatcamp/home',
    name: 'fatcamp-home',
    component: (res) =>
      require(['@/views/business-center/views/home/index'], res),
    meta: {
      keepAlive: true,
      title: '首页',
      des: '首页'
    }
  },
  {
    path: '/fatcamp/knowledge-base/second_class',
    name: 'fatcamp-second-class',
    component: (res) =>
      require([
        '@/views/business-center/views/knowledge-base/second-class/index'
      ], res),
    meta: {
      keepAlive: true,
      title: '分类',
      savedPosition: true,
      des: '分类',
      ifDoFresh: true
    }
  },
  {
    path: '/fatcamp/knowledge-base/case-detail',
    name: 'knowledge-base-case-detail',
    component: () =>
      import(
        '@/views/business-center/views/knowledge-base/case-library/detail/index'
      ),
    meta: { title: '案例详情', des: '案例详情' }
  },
  {
    path: '/fatcamp/knowledge-base/words-detail',
    name: 'knowledge-base-words-detail',
    component: () =>
      import(
        '@/views/business-center/views/knowledge-base/words-library/detail/index'
      ),
    meta: { title: '详情', des: '详情' }
  },
  {
    path: '/fatcamp/knowledge-base/picture-class',
    name: 'knowledge-base-picture-class',
    component: () =>
      import(
        '@/views/business-center/views/knowledge-base/picture-library/class/index'
      ),
    meta: {
      title: '夸夸图分类',
      des: '夸夸图分类',
      scrollTop: 0,
      keepScroll: true
    }
  },
  {
    path: '/fatcamp/preview-image',
    name: 'fatcamp-preview-image',
    component: () =>
      import('@/views/business-center/views/common/preview-image/index'),
    meta: { title: '查看图片', des: '查看图片' }
  },
  {
    path: '/fatcamp/knowledge-base/video-detail',
    name: 'fatcamp-video-detail',
    component: () =>
      import(
        '@/views/business-center/views/knowledge-base/video-library/detail/index'
      ),
    meta: { title: '直播单元详情', des: '直播单元详情' }
  },
  {
    path: '/fatcamp/publish',
    name: 'fatcamp-publish',
    component: () =>
      import('@/views/business-center/views/common/publish/index'),
    meta: { title: '发布动态', des: '发布动态' }
  },
  {
    path: '/track-hot-list',
    name: 'track-hot-list',
    component: () =>
      import('@/views/business-center/views/track-hot-list/index'),
    meta: { title: '赛道热门达人榜', des: '主页' }
  },
  {
    path: '/inner-rank',
    name: 'inner-rank',
    component: () => import('@/views/business-center/views/inner-rank/index'),
    meta: { title: '内部排行', des: '主页' }
  },
  {
    path: '/vertical-video-rank',
    name: 'vertical-video-rank',
    component: () =>
      import('@/views/business-center/views/vertical-video-rank/index'),
    meta: { title: '垂类热门视频', des: '主页' }
  },
  {
    path: '/data-report',
    name: 'data-report',
    component: () => import('@/views/business-center/views/data-report/index'),
    meta: { title: '数据报表', des: '主页' }
  }
]

export default routers
